<template>
  <layout-content>
    <i-button slot="top-buttons" size="large" type="primary" @click="create_button_click">
      {{ $t('autocaller_v2.breadcrumb.campaign.new') }}
    </i-button>
    <filter-component />
    <table-component />
  </layout-content>
</template>
<script>
  import TableComponent from '@autocaller_v2/components/campaigns-table.vue';
  import FilterComponent from '@autocaller_v2/components/campaigns-table-filter.vue';
  export default {
    components: { TableComponent, FilterComponent },
    methods: {
      create_button_click: function() {
        this.$router.push({ name: 'autocaller_v2.campaign.new' });
      }
    }
  };
</script>
